import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';



@Injectable()
export class SystemAdminEffects {


  constructor(private actions$: Actions) {}
}
